import { render, staticRenderFns } from "./ComplianceInformationStep.vue?vue&type=template&id=127847c1&"
import script from "./ComplianceInformationStep.vue?vue&type=script&lang=js&"
export * from "./ComplianceInformationStep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports